module.exports = __webpack_public_path__ + "img/Chateau-Chalon.683b795f.jpg";